import { css } from '@emotion/css'

import { mediaQueryHelper } from '@offerzen/pinata-shame'

import { fontSize, fontWeight, fontFamily, lineHeight, breakpoint } from '../../lib/styles'
import legacyColors from '../../lib/themes/colors'

const styles = {
  wrapper: css({
    fontFamily: fontFamily.heading,
    fontSize: fontSize.large,
    fontWeight: fontWeight.bold,
    lineHeight: lineHeight.default,
    color: legacyColors.darkEclipse,
    margin: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontWeight: fontWeight.medium,
    },
  }),
}

export default styles
